/**
 * Match Url with valid urls to avoid XSS on hrefs
 * @param url Original Url content
 * @returns The given Url if valid, an empty string otherwise
 */
export const sanitizeUrl = (url: string): string => {
  const urlRegex =
    "(https?://(?:www.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|www.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|https?://(?:www.|(?!www))[a-zA-Z0-9]+.[^s]{2,}|www.[a-zA-Z0-9]+.[^s]{2,})";
  return url.match(urlRegex) ? url : "";
};
